import { render, staticRenderFns } from "./MainMobile.vue?vue&type=template&id=f702ad92&scoped=true&"
import script from "./MainMobile.js?vue&type=script&lang=js&"
export * from "./MainMobile.js?vue&type=script&lang=js&"
import style0 from "./MainMobile.vue?vue&type=style&index=0&id=f702ad92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f702ad92",
  null
  
)

export default component.exports